export enum EEvidenceCp {
    CDCP = 'CDCP',
    CNB = 'CNB',
    MF = 'MF',
    CDCPDLT = 'CDCPDLT',
    JINY = 'JINY'
}
